import { motion } from "framer-motion";
import { Check } from "lucide-react";

interface SuggestedReasonsPickerProps {
  options: string[];
  selectedSuggestions: string[];
  onToggle: (reason: string) => void;
}

export function SuggestedReasonsPicker({
  options,
  selectedSuggestions,
  onToggle,
}: SuggestedReasonsPickerProps) {
  return (
    <div className="flex flex-wrap gap-3">
      {options.map((reason) => {
        const isSelected = selectedSuggestions.includes(reason);
        return (
          <motion.div
            key={reason}
            onClick={() => onToggle(reason)}
            className={`
              relative cursor-pointer rounded-md px-2 py-1.5 text-sm font-normal
              transition-all duration-200 ease-in-out
              ${
                isSelected
                  ? "bg-primary text-primary-foreground shadow-sm"
                  : "bg-muted text-muted-foreground hover:bg-muted/80"
              }
            `}
          >
            <div className="flex items-center gap-1.5">
              {isSelected && (
                <motion.span
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="flex items-center"
                >
                  <Check className="h-3.5 w-3.5" />
                </motion.span>
              )}
              <span>{reason}</span>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
